/**
 * RIJ customer-state — 标准登录态 API（供所有玩法/脚本有序使用）
 *
 * 数据来源：snippets/customer-state.liquid 注入的 window.RIJ.customer（最小字段）
 * Consent：window.Shopify.customerPrivacy（Shopify 官方 privacy API，未知一律按 false，合规保守）
 * 存储：storage 为功能性 localStorage（第一方、可清除、不跨站、不用于追踪）
 *
 * 用法：
 *   RIJ.customerState.isLoggedIn()          // 是否登录
 *   RIJ.customerState.displayName()         // 欢迎名（first_name 或 'friend'）
 *   RIJ.customerState.ordersCount()         // 订单数
 *   RIJ.customerState.isRepeatCustomer()    // 回头客（orders > 0）
 *   RIJ.customerState.hasTag('vip')         // 是否有某 tag
 *   RIJ.customerState.consent('marketing')  // 营销同意（未知 false）
 *   RIJ.customerState.storage.get/set/clear // 功能性存储，key 前缀 rij:
 */
(function () {
  const NS = (window.RIJ = window.RIJ || {});
  const raw = NS.customer || { isLoggedIn: false, id: null, firstName: null, ordersCount: 0, tags: [] };

  NS.customerState = {
    isLoggedIn() {
      return !!raw.isLoggedIn;
    },
    id() {
      return raw.id;
    },
    firstName() {
      return raw.firstName;
    },
    displayName() {
      return raw.firstName || 'friend';
    },
    ordersCount() {
      return Number(raw.ordersCount) || 0;
    },
    tags() {
      return Array.isArray(raw.tags) ? raw.tags : [];
    },
    hasTag(t) {
      return this.tags().includes(t);
    },
    isRepeatCustomer() {
      return this.ordersCount() > 0;
    },
    // Consent：Shopify customerPrivacy 的 marketing/analytics/preferences/sale_of_data
    consent(type) {
      const cp = window.Shopify && window.Shopify.customerPrivacy;
      if (!cp) return false;
      const v = cp[type];
      return v === undefined ? false : !!v;
    },
    // 功能性存储：第一方、可清除、不跨站
    storage: {
      get(key) {
        try { return JSON.parse(localStorage.getItem('rij:' + key)); } catch (e) { return null; }
      },
      set(key, val) {
        try { localStorage.setItem('rij:' + key, JSON.stringify(val)); } catch (e) {}
      },
      clear(key) {
        try { localStorage.removeItem('rij:' + key); } catch (e) {}
      },
    },
  };
})();
